'use strict'

define [], () ->
  ($scope, $state, RentappService, $http, RENTAPPLICATION_API_URL ) ->
    $scope.close_error = () ->
      $scope.result = null

    $scope.resetPwd = (email) ->
      $scope.sending_instructions = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/request_password_reset/",
        email: email
      .then ->
        $scope.result = 'success'
      .catch ->
        $scope.result = 'error'
      .finally () ->
        $scope.sending_instructions = false




// WEBPACK FOOTER //
// ./components/home/password_reset/password_reset.coffee